import { useNavigate } from 'react-router-dom';
import { FileText, Receipt, Users, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const QuickActionsBar = () => {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'New Estimate',
      icon: FileText,
      onClick: () => navigate('/estimates/create'),
      variant: 'default' as const,
    },
    {
      label: 'New Invoice',
      icon: Receipt,
      onClick: () => navigate('/invoices/create'),
      variant: 'outline' as const,
    },
    {
      label: 'Add Customer',
      icon: Users,
      onClick: () => navigate('/customers/new'),
      variant: 'outline' as const,
    },
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {actions.map((action) => {
        const Icon = action.icon;
        return (
          <Button
            key={action.label}
            variant={action.variant}
            size="sm"
            onClick={action.onClick}
            className="gap-2"
          >
            <Plus className="h-3.5 w-3.5" />
            <Icon className="h-4 w-4" />
            <span className="hidden sm:inline">{action.label}</span>
          </Button>
        );
      })}
    </div>
  );
};

export default QuickActionsBar;
